import { gql } from "@apollo/client";

export const CREATE_ASSIGNMENT_MUTATION = gql`
    mutation CreateWorkOrderAssignment($input: CreateWorkOrderAssignmentInput!) {
        createWorkOrderAssignment(input: $input) {
            assignmentType
            createdAt
            deletedAt
            id
            updatedAt
            userId
            workOrderId
        }
    }
`;

// Update Assignment Mutation

export const UPDATE_ASSIGNMENT_MUTATION = gql`
    mutation updateWorkOrderAssignment($input: UpdateWorkOrderAssignmentInput!) {
        updateWorkOrderAssignment(input: $input) {
            assignmentType
            createdAt
            deletedAt
            id
            updatedAt
            userId
            workOrderId
        }
    }
`;

// Delete Assignment Mutation

export const DELETE_ASSIGNMENT_MUTATION = gql`
    mutation RemoveWorkOrderAssignment($id: ID!) {
        removeWorkOrderAssignment(id: $id)
    }
`;

// Create Asset Type Mutation
// Create Product Type Mutation
